import * as React from "react"
import { CSSProperties } from "react"
import { MeetingData } from "../EntityType"
import MobileCrmData from "../MobileCrmData"
import { ListItemWrapper } from "../list/ListItemWrapper"
import { ListItemStateContent } from "../list/ListItemStateContent"
import { ListItemCallbackProps } from "../list/MobileListDataWrapper"
// import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// import {Link} from "react-router-dom";

export type MeetingDataProps = {
	data: MeetingData, table: string,
	style: CSSProperties,
	index: number,
} & ListItemCallbackProps;

const ItemLeftSide = ( props: MeetingDataProps ) => {
	return <>
		<div className={ "itemFirm ellipsis" }>
			<span dangerouslySetInnerHTML={ { __html: props.data.firmName } } />
		</div>
	</>
}
const ItemRightSide = ( props: MeetingDataProps ) => {
	return <>
		{ props.data.dateFrom &&
			<div className={ "itemDateNextAction ellipsis" }>{ props.data.dateFrom }</div> }
		{
			props.data.permission.assignedUserId.map( ( userId, index ) => (
				<span key={ index }>
					{ MobileCrmData.getUserNameById( userId ) }
 				</span>
			) )
		}
	</>
}
const ItemBasic = ( props: MeetingDataProps ) => {
	return <ListItemStateContent statusColor={ props.data.statusColor } statusName={ props.data.statusName } isClosed={ props.data.isClosed } />
}

export const MeetingListItem = ( props: MeetingDataProps ) => {
	return <ListItemWrapper
		tagColor={ props.data.statusColor }
		name={ props.data.name } table={ props.table }
		permission={ props.data.permission } id={ props.data.id }
		isClosed={ props.data.isClosed }
		itemExpandLeftElement={ <ItemLeftSide { ...props } /> }
		itemBasicElement={ <ItemBasic { ...props } /> }
		itemExpandRightElement={ <ItemRightSide { ...props } /> }
		style={ props.style } index={ props.index }
		onDeleteItemCallback={ props.onDeleteItemCallback }
		onEditItemCallback={ props.onEditItemCallback }
		onListMessageCallback={ props.onListMessageCallback }
		onLoadingStart={props.onLoadingStart}
	/>

}
